export const RULE = 'ruleValue';
export const TYPE = 'outputType';
export const INPUT_TYPE = 'inputType';
export const VALUE = 'value';
export const PAGE = 'pageValue';
export const FLOW = 'flowValue';



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/constants/outputViewEngineConstants.constant.ts